import React from 'react'
import './Cart_Similar_Products.css'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useNavigate } from 'react-router-dom'
import { encodeId } from '../../../utils/common'

const Cart_Similar_Products = ({product}) => {

    const data = [
        {
            img: "/assets/images/products/img1.png",
            name: "Broccoli",
            subtext: "",
            price: "₹ 120.00",
            mrp: "₹ 135.00"
        },
        {
            img: "/assets/images/products/img1.png",
            name: "Yellow Capscdfsdf",
            subtext: "(Yellow Bell Paper)",
            price: "₹ 120.00",
            mrp: "₹ 135.00"
        },

        {
            img: "/assets/images/products/img1.png",
            name: "Broccoli",
            subtext: "(Yellow Bell Paper)",
            price: "₹ 120.00",
            mrp: "₹ 135.00"
        },
        {
            img: "/assets/images/products/img1.png",
            name: "Broccoli",
            subtext: "",
            price: "₹ 120.00",
            mrp: "₹ 135.00"
        },

        {
            img: "/assets/images/products/img1.png",
            name: "Broccoli",
            subtext: "",
            price: "₹ 120.00",
            mrp: "₹ 135.00"
        },
        {
            img: "/assets/images/products/img1.png",
            name: "Broccoli",
            subtext: "",
            price: "₹ 120.00",
            mrp: "₹ 135.00"
        },

        {
            img: "/assets/images/products/img1.png",
            name: "Broccoli",
            subtext: "",
            price: "₹ 120.00",
            mrp: "₹ 135.00"
        },
        {
            img: "/assets/images/products/img1.png",
            name: "Broccoli",
            subtext: "",
            price: "₹ 120.00",
            mrp: "₹ 135.00"
        },



        {
            img: "/assets/images/products/img1.png",
            name: "Broccoli",
            subtext: "",
            price: "₹ 120.00",
            mrp: "₹ 135.00"
        },
        {
            img: "/assets/images/products/img1.png",
            name: "Broccoli",
            subtext: "",
            price: "₹ 120.00",
            mrp: "₹ 135.00"
        },
    ]

    const navigate = useNavigate()

    return (
        <section className='Similar_Products Cart_Similar_Products'>

            <p className='section_title'>Similar Products</p>

            <div className='swiper_div'>
                <Swiper
                    spaceBetween={15}
                    pagination={{
                        dynamicBullets: true,
                        clickable: true
                    }}
                    autoplay={{ delay: 300 }}
                    className="common_swiper"
                    breakpoints={{
                        0: {
                            slidesPerView: 1.3,
                        },
                        320: {
                            slidesPerView: 1.8,
                        },
                        380: {
                            slidesPerView: 2.5,
                        },
                        500: {
                            slidesPerView: 3,
                        },
                        768: {
                            slidesPerView: 4,
                        },
                        992: {
                            slidesPerView: 5,
                        },
                        1200: {
                            slidesPerView: 6,
                        },
                        1400: {
                            slidesPerView: 4.5,
                        },

                    }}
                >
                    {product?.length > 0 && product?.map((item) => {
                        return (
                            <SwiperSlide >
                                <div className='product_card'  onClick={() => {navigate(`/product-description/${encodeId(item?.id)}`)}}>
                                    <div className='img_holder'>
                                        <img src={process.env.REACT_APP_IMG_URL + item?.image} className='prod_img' />
                                    </div>
                                    <div className='text_holder'>
                                        <p className='name_text'>{item?.name}</p>

                                        {item?.subtext ? (
                                            <p className='subtext'>{item?.subtext}</p>
                                        )
                                            : (
                                                <p className='hidden_text'>test</p>
                                            )
                                        }

                                        <p className='price'>₹{item?.Product_Variants[0]?.price}</p>
                                        <p className='mrp'>₹{item?.Product_Variants[0]?.mrp}</p>

                                    </div>
                                </div>
                            </SwiperSlide>
                        )
                    })}
                </Swiper>
            </div>


        </section>
    )
}

export default Cart_Similar_Products
